import { WorkflowConfigType } from '@monorepo/interfaces';

export interface WorkflowConfigTypesTranslationsRecord {
    value: WorkflowConfigType;
    label: string;
}

export const WORKFLOW_CONFIG_TYPES_TRANSLATIONS_RECORD: WorkflowConfigTypesTranslationsRecord[] = [
    {
        value: WorkflowConfigType.TECHNICAL_WORKFLOW,
        label: 'workflow.workflow-config-details.workflow-type-options.technical-workflow'
    },
    {
        value: WorkflowConfigType.COMMERCIAL_WORKFLOW,
        label: 'workflow.workflow-config-details.workflow-type-options.commercial-workflow'
    }
];
